import { createStore, createEvent, createEffect, combine } from 'effector';
import request from '@helpers/request';
import api from '@constants/endpoints';
import { get } from 'lodash';
import createPreloadersStore from './preloaders';
import createPaginationStore from './pagination';

export const reset = createEvent('Chat claims reset');

export const getList = createEffect({
  name: 'getList',
  async handler(accountId: string) {
    const { current, pageSize } = pagination.getState();

    const data = {
      pagination: {
        pageSize,
        type: 'PAGE',
        page: (current || 1) - 1,
      },
    };

    const response = await request(api.spam.getUserChatClaims, {
      data,
      urlParams: {
        accountId,
      },
    });

    return response;
  },
});

const { pagination, setPagination } = createPaginationStore({
  getList,
  listName: 'chatClaims',
  resetEvent: reset,
  bodyPath: ['data', 'body', 'page'],
});

export { setPagination };

const preloaders = createPreloadersStore([getList]);

const userChatClaims = createStore([])
  .on(getList.done, (state, { result }) => get(result, ['data', 'body', 'result', 'page']))
  .reset(reset);

const chatClaims = combine({
  preloaders,
  userChatClaims,
  pagination,
  setPagination,
});

export default chatClaims;
